"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Velocity = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("rect", { width: 3.593, height: 17.196, x: 18.496, y: 15.427, rx: 1.796, transform: "rotate(90 18.496 15.427)" }),
    /* @__PURE__ */ React.createElement(
      "rect",
      {
        width: 3.593,
        height: 11.245,
        x: 17.269,
        y: 3.848,
        fillOpacity: 0.6,
        rx: 1.796,
        transform: "rotate(90 17.27 3.848)"
      }
    ),
    /* @__PURE__ */ React.createElement("rect", { width: 3.593, height: 11.169, x: 22.7, y: 9.722, rx: 1.796, transform: "rotate(90 22.7 9.722)" })
  );
};
export default Velocity;
